export default (superClass) => {
    return class extends superClass {
        
        get website() {
            return this._data.website;
        }
    }
}